import Model from '@/store/plugins/orm/Model'
import { Shift, CashRegister, AppEvent } from './ModelRepository'

import ApiService from '@/services/ApiService';
import HashGen from '@/utilities/HashGen';

export class CashRegisterTransaction extends Model {
    static get entity() {
        return 'cash_register_transactions';
    }

    static get primaryKey() {
        return 'hash';
    }

    static get DATE_FORMAT() {
        return 'YYYY-MM-DDTHH:mm:ssZ';
    }

    static fields() {
        return {
            id: this.attr(null),
            hash: this.attr(HashGen.regular()),
            cash_register_id: this.attr(null),
            shift_id: this.attr(null),
            shift_hash: this.attr(null),
            amount: this.attr('0.0000', value => _.round(value, 4).toFixed(4)),
            issued_at: this.attr(null),
            fiscal_code: this.attr(null),
            register_status: this.attr(null),
            registered_at: this.attr(null),

            shift: this.belongsTo(Shift, 'shift_hash'),
            cashRegister: this.belongsTo(CashRegister, 'cash_register_id'),

            sync_needed: this.attr(null)
        };
    }

    /**
     * Sync the data with the server
     */
    async sync() {
        if (!this.$store().getters.isOnline) {
            this.$save();
            return { success: true };
        }

        try {
            const response = await ApiService.post(`/cash-registers/transactions`, this.$toJson())
            this.$fill(response.data);
            CashRegisterTransaction.insert({ data: [response.data] });

            AppEvent.build('cashRegisterTransactionAdd', {
                id: response.data.id,
                cash_register_id: response.data.cash_register_id
            }).send()

            return { success: true };
        } catch(error) {
            return { success: false };
        }
    }

    getAmount() {
        return Money.parse(this.amount);
    }

    getIssuedAt() {
        if(!this.issued_at){
            return null;
        }

        return moment.utc(this.issued_at).local();
    }
}

export default CashRegisterTransaction
